import { createApiClient } from './apiClient'
import { PaginatedResponse } from '../types/catalog'
import {
  SupportTicket,
  SupportTicketDetail,
  UpdateTicketPayload,
  AddMessagePayload,
  SupportMessage,
} from '../types/support'

export const supportService = (token: string | null) => {
  const api = createApiClient(token)

  return {
    list: (page: number, perPage: number, status?: string, type?: string) => {
      const params = new URLSearchParams({ page: String(page), perPage: String(perPage) })
      if (status) params.set('status', status)
      if (type) params.set('type', type)
      return api.get<PaginatedResponse<SupportTicket>>(`/api/support-tickets?${params}`)
    },

    show: (id: string) => api.get<SupportTicketDetail>(`/api/support-tickets/${id}`),

    update: (id: string, data: UpdateTicketPayload) =>
      api.patch<SupportTicketDetail>(`/api/support-tickets/${id}`, data),

    addMessage: (id: string, data: AddMessagePayload) =>
      api.post<SupportMessage>(`/api/support-tickets/${id}/messages`, data),

    escalate: (id: string) =>
      api.post<{ linearIssueId: string; linearIssueUrl: string }>(
        `/api/support-tickets/${id}/escalate`,
        {}
      ),

    unreadCount: () => api.get<{ count: number }>('/api/support-tickets/unread-count'),
  }
}
